<div *ngIf="notification.message" class="notification is-overlay">
    <div class="notification__content">
        <div class="notification__message" [class.is-error]="!!notification.error">
            {{ notification.message }}
        </div>
        <app-sh-progress *ngIf="notification.progress" [value]="notification.progress"></app-sh-progress>
    </div>
</div>
